"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var Logo = /** @class */ (function (_super) {
    __extends(Logo, _super);
    function Logo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Logo.prototype.render = function () {
        var _a = this.props, settings = _a.settings, alt = _a.alt, alternative = _a.alternative, className = _a.className, reverse = _a.reverse, width = _a.width;
        return alternative ? (reverse && settings && settings.logo_alt_light ? (React.createElement("div", { className: className || "" },
            React.createElement("a", { href: "/", className: "relative block", title: alt },
                React.createElement("img", { src: settings.logo_alt_light, alt: alt || null, width: width || null, className: "block max-w-full " + (!width ? " w-full" : width) })))) : !reverse && settings && settings.logo_alt_dark ? (React.createElement("div", { className: className || "" },
            React.createElement("a", { href: "/", className: "relative block", title: alt },
                React.createElement("img", { src: settings.logo_alt_dark, alt: alt || null, width: width || null, className: "block max-w-full " + (!width ? " w-full" : width) })))) : null) : settings && settings.logo_image ? (React.createElement("div", { className: className || "" },
            React.createElement("a", { href: "/", className: "relative block", title: alt },
                React.createElement("img", { src: settings.logo_image, alt: alt || null, width: width || null, className: "block max-w-full " + (!width ? " w-full" : width) })))) : (React.createElement("div", { className: className || "" },
            React.createElement("a", { href: "/", className: "relative " + reverse, title: alt }, reverse ? (React.createElement(Snippets.Svg, { name: "logo", width: width || null, className: "block max-w-full" + (!width ? " w-full" : "") })) : (React.createElement(Snippets.Svg, { name: "logo-light", width: width || null, className: "block max-w-full" + (!width ? " w-full" : "") })))));
    };
    return Logo;
}(React.PureComponent));
exports.Logo = Logo;
